import React, { useState } from "react";
import Modalheader from "components/modal/components/header";
import ModalBody from "components/modal/components/body";
import { Import, Warning } from "assets/icons";
import ModalFooter from "components/modal/components/footer";
import Button from "components/button";
import { toast } from "react-toastify";
import Divider from "components/divider/divider";
import useModal from "components/modal/useModal";
import UseContext from "hooks/useContext";
import ApiDatabase from "server";
import LoadingButton from "components/button/loading.js";

const Modalformation = () => {
    const { refreshLoadWorker } = UseContext();
    const { toggle } = useModal();
    const [typeFormation, setTypeFormation] = useState("");
    const [description, setDescription] = useState("");
    const token = localStorage.getItem("xsrfToken");
    const [loading, setLoading] = useState(false);

    const handleSubmit = async () => {
        if (typeFormation && description) {
            setLoading(true);
            ApiDatabase.postUserFormationWithoutFile(
                {
                    token: token,
                    formation: typeFormation,
                    description: description,
                    isParsing: false,
                },
                (data) => {
                    setLoading(false);
                    //console.log(data)
                    toast.success("Formation ajoutée avec succès");
                    toggle();
                    refreshLoadWorker();
                },
                (err) => {
                    setLoading(false);
                    console.log(err);
                    toast.error("Une erreur est survenue");
                }
            );
        } else {
            setLoading(false);
            toast.error("Veuillez remplir tous les champs");
        }
    };

    return (
        <>
            <Modalheader hide={toggle} hideShow={true}>
                Ajouter une formation
            </Modalheader>
            <ModalBody>
                <div className="flex flex-col w-full gap-2">
                    <select
                        name=""
                        id=""
                        onChange={(e) => setTypeFormation(e.target.value)}
                        className="w-full h-10 pl-3 pr-8 ft-b placeholder-gray-600 border rounded-lg "
                    >
                        <option value="">Sélectionner</option>
                        <option value="CAP ou équivalents">
                            CAP ou équivalents
                        </option>
                        <option value="BEP ou équivalents">
                            BEP ou équivalents
                        </option>
                        <option value="Bac (général, technique ou professionnel) ou équivalents">
                            Bac (général, technique ou professionnel) ou
                            équivalents
                        </option>
                        <option value="Bac+2 (BTS, DUT ou équivalents)">
                            Bac+2 (BTS, DUT ou équivalents)
                        </option>
                        <option value="Bac+3 (Licence ou équivalents)">
                            Bac+3 (Licence ou équivalents)
                        </option>
                        <option value="Bac+4 (Maitrise ou équivalents)">
                            Bac+4 (Maitrise ou équivalents)
                        </option>
                        <option value="Bac+5 et plus (Master ou équivalents)">
                            Bac+5 et plus (Master ou équivalents)
                        </option>
                    </select>
                </div>
                <div className={"w-full mt-3"}>
                    <label className="ft-sm text-gray-500">
                        <div>Description</div>
                        <div>
                            <input
                                type="text"
                                className="w-full h-10 pl-3 pr-8 ft-b border rounded-lg text-gray-900"
                                value={description}
                                onChange={(e) => setDescription(e.target.value)}
                            />
                        </div>
                    </label>
                </div>
            </ModalBody>
            <ModalFooter>
                {loading ? (
                    <LoadingButton size={"LG"} />
                ) : (
                    <>
                        <Button
                            size={"LG"}
                            color={"SECONDARY"}
                            onClick={toggle}
                        >
                            Annuler
                        </Button>
                        <Button size={"LG"} onClick={handleSubmit}>
                            Confirmer
                        </Button>
                    </>
                )}
            </ModalFooter>
        </>
    );
};

export default Modalformation;
